import { IWalletTags } from '@kattana-io/common';
import {
  SET_WALLET_TAGS,
  CLEAR_WALLET_TAGS,
  UPDATE_WALLET_TAGS_SUCCESS,
} from '../actions/wallet_tags';

const defaultState: IWalletTags = {};

const walletTags = (
  state: IWalletTags = defaultState,
  action: any
): IWalletTags => {
  switch (action.type) {
  case SET_WALLET_TAGS:
    return action.payload;
  case UPDATE_WALLET_TAGS_SUCCESS:
    return {
      ...state,
      [`${action.payload.network}`]: {
        ...state[`${action.payload.network}`],
        [`${action.payload.wallet}`]: action.payload.tags,
      },
    };
  case CLEAR_WALLET_TAGS: {
    return {};
  }
  default:
    return state;
  }
};

export default walletTags;
